import { FC } from 'react';
import useResponsiveRedux from '../Hooks/useResponsiveRedux';
import ResetPassword from '../../pages/ResetPassword';
import ResetPasswordMobile from '../../pages/Mobile/ResetPasswordMobile';

const ResetPasswordResponsive: FC = () => {
  const { isMobile } = useResponsiveRedux();
  return isMobile ? <ResetPasswordMobile /> : <ResetPassword />;
};

export default ResetPasswordResponsive;
